import type { CommentContentObject, ContentObject } from 'models';
import { routes } from 'routes/routes';

const getOwnContentObjectPath = (item: Exclude<ContentObject, { type: 'comment' }>) => {
  switch (item.type) {
    case 'activity':
      return routes.contentObjects.activities(item.activity.id);
    case 'event':
      return routes.contentObjects.events(item.event.id);
    case 'giving':
      return routes.giving.detail(item.giving.id);
    case 'kudo':
      return routes.contentObjects.kudos(item.kudo.id);
    case 'poll':
      return routes.contentObjects.polls(item.poll.id);
    case 'post':
      return routes.contentObjects.posts(item.post.id);
    case 'video':
      throw new Error(`Not implemented yet: ${item.type} case`);
    case 'withings_order_post':
      return routes.contentObjects.withingsOrderPosts(item.withings_order_post.id);
  }
};

const getTopParentContentObjectPath = (item: CommentContentObject) => {
  switch (item.topParentType) {
    case 'activity':
      return routes.contentObjects.activities(item.topParentShareableId);
    case 'event':
      return routes.contentObjects.events(item.topParentShareableId);
    case 'kudo':
      return routes.contentObjects.kudos(item.topParentShareableId);
    case 'poll':
      return routes.contentObjects.polls(item.topParentShareableId);
    case 'post':
      return routes.contentObjects.posts(item.topParentShareableId);
    case 'withings_order_post':
      return routes.contentObjects.withingsOrderPosts(item.topParentShareableId);
  }
};

const getCommentPath = (item: CommentContentObject) => {
  const commentPathSegment = item.topParentId === item.parentId ? item.id : `${item.parentId}/${item.id}`;

  return `${getTopParentContentObjectPath(item)}/comments/${commentPathSegment}`;
};

export const generateContentObjectPath = (item: ContentObject) =>
  item.type === 'comment' ? getCommentPath(item) : getOwnContentObjectPath(item);
